import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import OrganismPlayerVideo from '~/components/organisms/player-video/player-video.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'watch-a-video' }, () => [
    h(UiComponentWrapper, { class: 'content' }, () => [
      h(UiComponentHeading, { as: 'paragraph', level: 3 }, () => [props.record.title]),
      h(UiComponentParagraph, {}, () => [props.record.text]),
      h(UiComponentWrapper, { class: 'actions' }, () => [
        h(
          AtomButton,
          {
            action: props.primaryButton.action,
            label: 'Services section CTA',
            size: 'l',
            to: props.primaryButton.to,
          },
          () => [props.primaryButton.slot],
        ),
        h(
          AtomButton,
          {
            size: 'l',
            type: 'secondary',
            to: '#form-demo',
          },
          () => [props.global.contactSales],
        ),
      ]),
    ]),
    h(OrganismPlayerVideo, {
      autoPlay: false,
      class: 'video',
      posterSrc: props.record.asset.video.thumbnailUrl,
      videoSrc: props.record.asset.video.streamingUrl,
    }),
  ])
}

Functional.props = {
  global: {
    required: true,
    type: Object,
  },
  primaryButton: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
